import { DeviceEntityModel } from "src/store/models/entity/device/entity";
import { DeviceHelperModel } from "src/store/models/entity/device/helper";

export const encooDeviceModels = {
  entity: DeviceEntityModel,
  helper: DeviceHelperModel,
};
